import { render, staticRenderFns } from "./ConsumablesDetails.vue?vue&type=template&id=6130bf3c&scoped=true"
import script from "./ConsumablesDetails.vue?vue&type=script&lang=js"
export * from "./ConsumablesDetails.vue?vue&type=script&lang=js"
import style0 from "./ConsumablesDetails.vue?vue&type=style&index=0&id=6130bf3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6130bf3c",
  null
  
)

export default component.exports